import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { apiService } from '../services/apiService';
import StatusBadge from '../components/StatusBadge';
import TaskSubNav from '../components/TaskSubNav';
import TaskAttachments from '../components/TaskAttachments';
import { DSBackLink, DSCard, DSIcon, DSBadge, DSButton } from '../design-system/primitives';
import './taskManagementShared.css';

const STATUS_VARIANT = { pending: 'warning', approved: 'success', rejected: 'neutral' };

function MySuggestions() {
  const navigate = useNavigate();
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    apiService.getTaskSuggestions({ mine: true })
      .then((res) => setSuggestions(res.data || []))
      .catch((err) => setError(err.response?.data?.error || 'Unable to load suggestions'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="tm-page">
      <DSBackLink onClick={() => navigate(-1)}>Back</DSBackLink>
      <div className="tm-section">
        <div className="tm-section-header-row">
          <h1>My Suggestions</h1>
          <DSButton to="/tasks/suggest" tone="primary" appearance="solid" size="sm">+ New</DSButton>
        </div>
        <p>You've submitted {suggestions.length} suggestion{suggestions.length === 1 ? '' : 's'}. Approved ones become real tasks.</p>

        {error && <div className="error-message">{error}</div>}
        {loading ? (
          <div className="loading-inline">Loading...</div>
        ) : suggestions.length === 0 ? (
          <div className="tm-empty-state">
            <h2>No suggestions yet</h2>
            <DSButton to="/tasks/suggest" tone="primary" appearance="solid" size="md">+ Suggest Another Task</DSButton>
          </div>
        ) : (
          <div className="tm-card-list">
            {suggestions.map((s) => (
              <DSCard key={s.id} variant="elevated" bgVariant="default" borderVariant="subtle" cornerVariant="lg" className="tm-suggestion-card">
                <div className="tm-suggestion-header">
                  <h3>{s.title}</h3>
                  <StatusBadge label={s.status} variant={STATUS_VARIANT[s.status]} uppercase />
                </div>
                <div className="tm-suggestion-meta">Submitted {new Date(s.created_at).toLocaleDateString()}</div>
                {s.description && <p className="tm-preserve-lines">{s.description}</p>}
                <TaskAttachments owner="suggestion" ownerId={s.id} />
                {s.wants_to_do_it && <DSBadge variant="brand" size="sm" leadingIcon={<DSIcon name="user" />}>Wants to do it</DSBadge>}
                {s.status === 'approved' && (
                  <div className="tm-suggestion-outcome success">
                    <DSIcon name="checkCircle" /> This became a real task! <Link to={`/tasks/${s.resulting_task_id}`}>Check it out</Link>
                  </div>
                )}
                {s.status === 'rejected' && (
                  <div className="tm-suggestion-outcome">
                    This suggestion wasn't added to the task list. Thanks for flagging it regardless!
                  </div>
                )}
              </DSCard>
            ))}
          </div>
        )}
      </div>
      <TaskSubNav />
    </div>
  );
}

export default MySuggestions;
